import * as React from 'react';

import * as styles from './ReviewsFixedFooterLayout.css';

interface IReviewsFixedFooterLayout {
  review: React.ReactElement | null;
  question: React.ReactElement | null;
  moderation: React.ReactElement | null;
}
export const ReviewsFixedFooterLayout: React.FC<IReviewsFixedFooterLayout> = ({ review, question, moderation }) => {
  return (
    <div className={styles['container']}>
      {review && <div className={styles['item']}>{review}</div>}
      {question && <div className={styles['item']}>{question}</div>}
      {moderation && <div className={styles['link']}>{moderation}</div>}
    </div>
  );
};
